import { EVENT_LOCATIONS, EVENT_LOCATIONS_RESULT, CLEAR_ENTITIES } from '../actions/action-types';

export const eventLocationsReducer = (reducer, types, actionToKey) => {
  const nextReducer = reducer(types, actionToKey);

  return (state, action) => {
    const newState = { ...nextReducer(state, action) };
    switch (action.type) {
      case EVENT_LOCATIONS:
        return {
          ...newState,
          loading: true,
        };
      case EVENT_LOCATIONS_RESULT:
        return {
          ...newState,
          loading: false,
        };
      case CLEAR_ENTITIES:
        if (action.entities && action.entities.indexOf('eventLocations') !== -1) {
          return {
            ...newState,
            objects: {},
            preparing: true,
          };
        }
        return newState;
      default:
        return newState;
    }
  };
};
